
import * as React from 'react';

import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import { ConfirmationDialog } from '../../../../components/Elements/ConfirmationDialog';
import { DELETE_FIELD } from '../../../../../../queries';
import { useMutation } from 'react-apollo';
import { useHistory } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom';

const FIELD_APP_URL = process.env.REACT_APP_FIELD_MGR_ROOT_URL;

type DeleteFieldProps = {
    fieldId: number
};

export const DeleteField = ({fieldId}: DeleteFieldProps) => {
    const history = useHistory();
    const match = useRouteMatch(`${FIELD_APP_URL}/:vp/fields`);
    const [done, setDone] = React.useState(false);

    const [deleteFieldMutation] = useMutation(DELETE_FIELD, {
        awaitRefetchQueries: true,
        refetchQueries: [
            'GetFields' // Query name
        ],
        onCompleted: () => { 
            history.push(`${match.url}`);
        }
    });

    const deleteField = async () => {
        await deleteFieldMutation({ variables: {id: fieldId} } );
        setDone(true);
    }

    return (
        <ConfirmationDialog
            title="Delete Block"
            body="Are you sure you want to delete this block?"
            isDone={done}
            triggerButton={
                <div title="Delete" className="text-sm ml-2 align-items-center bg-danger d-flex flex-lg-row justify-content-center rounded-circle text-white" style={{width: '25px', height: '25px'}}>
                    <FontAwesomeIcon icon={faTimes} />
                </div>
            }
            confirmButton={
                <Button variant="primary" onClick={async () => deleteField()}>
                    Delete
                </Button>
            }  
        />
    );
};